<template>
  <div>
    <!-- 工具栏 -->
    <div ref="toolbar" class="toolbar"></div>

    <!-- 编辑器区域 -->
    <div ref="editor" class="text" style="height: 200px"></div>
  </div>
</template>

<script>
import E from "wangeditor";

export default {
  name: "RichTextEditor",
  data() {
    return {
      editor: null,
      value: "<p>初始内容</p>", // 初始 HTML 内容
    };
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    initEditor() {
      const editor = new E(this.$refs.toolbar, this.$refs.editor);

      // 配置项
      editor.config.placeholder = "请输入内容...";
      editor.config.showFullScreen = true;

      // 设置初始内容
      editor.txt.html(this.value);

      // 监听内容变化
      editor.config.onchange = (newHtml) => {
        this.value = newHtml;
      };

      // 创建编辑器
      editor.create();

      this.editor = editor;
    },
    getContent() {
      return this.editor.txt.html();
    },
    setContent(html) {
      this.editor.txt.html(html);
    },
    clearEditorContent() {
      if (this.editor) {
        // 使用 setText("") 或者 change 事件来清空内容
        this.editor.txt.html("");
      }
    },
  },
  beforeDestroy() {
    // 销毁编辑器
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
};
</script>

<style scoped>
.toolbar {
  border: 1px solid #ccc;
  margin-bottom: -1px;
}
.text {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
}
</style>
